//import { Component, Input, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

//import { ApiRequestsService } from '@base/api/api.gateway';
//import { ProjectsService } from '@eyrus/shared/services';


import { Component, Input, Output, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiRequestsService } from '@base/api/api.gateway';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HelpersService, HeaderService, NavigationService } from '@base/shared/services';
import { ProjectsService } from '@eyrus/shared/services';
import { TranslateService } from '@ngx-translate/core';
import { get } from 'lodash';
import { EyrusWarningModalComponent } from '@base-shared/components/warning-modal/warning-modal.component';


@Component({
  selector: 'dailylog-new-task-content',
  templateUrl: './new-task-modal.component.html',
  styleUrls: [
    './new-task-modal.component.sass',
    //'@eyrus/modules/daily-logs/submitter/tasks/tasks.component.sass'
    '../../../../../modules/daily-logs/submitter/tasks/tasks.component.sass'
  ]
})

export class NewTaskModalContent {

  taskForm: FormGroup;
  max = 100;
  min = 0;
  step = 5;
  progress = 0;
  loading: Boolean = true;
  currentTask: any;
  readOnly: Boolean = false;
  isMobile: Boolean = false;

  private subscriptions: any = {};
  @Input() currentTaskId;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    //private api: ApiRequestsService,
    //private projectService: ProjectsService,
    //
    private navigator: NavigationService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private api: ApiRequestsService,
    private helper: HelpersService,
    private projectService: ProjectsService,
    private translate: TranslateService,
    private headerService: HeaderService,
    //
  ) { }



  /** TODO: use task.component */



  ngOnInit() {

    this.bootstrapForm({});

    this.currentTask = this.activatedRoute.snapshot.paramMap.get('id') || this.currentTaskId;
    if (this.currentTask) {
      this.getCurrentTask();
      this.headerService.setIcon({
        icon: 'ae-delete',
        container: true,
        action: () => {
          this.confirmDelete();
        }
      });
    }

    this.loading = false;
    this.subscriptions.queryParams = this.activatedRoute.queryParams
      .subscribe(params => {
        this.readOnly = params.statusTypeName ? params.statusTypeName === 'submitted' : false;

        this.headerService.setIcon({});
      });

  }

  ngOnDestroy() {
    const keys = Object.keys(this.subscriptions);
    keys.forEach((key) => this.subscriptions[key].unsubscribe());
    this.removeIconFromHeader();
  }

  /**
   * Cancel task creation / edition
   */
  cancel() {
    if (this.isMobile) {
      this.navigator.navigate({
        title: 'task.task',
        subview: true,
        stepsBack: this.currentTask ? 2 : 1,
        type: 'basic'
      });
    } else {
      this.closeModal();
    }
  }


  /**
   * Close current Modal
   * @param {[type]} result [description]
   */
  closeModal(result?) {
    this.activeModal.close(result);
  }

  save({ value, valid }: { value: any, valid: boolean }) {

    if (!valid) {
      this.helper.displayFormErrors(this.taskForm);
      return;
    }

    this.loading = true;

    this.helper.setformAsValid(this.taskForm);

    this.projectService.createDailyLog()
      .then(() => {

        const dailyLogId = this.projectService.dailyLog;

        let payload: any = {
          task: value.taskName,
          percentComplete: this.progress / 100,
          dailyLogId
        };

        if (this.currentTask)
          payload = this.generatePatchOp(value);

        const action = this.currentTask ? this.api.dailyLogs.updateSubmitterTask(dailyLogId, this.currentTask, payload) :
          this.api.dailyLogs.storeSubmitterTask(dailyLogId, payload);

        return action.toPromise();
      })
      .then((res) => {

        const _label = this.currentTask ? 'common.successfullyUpdated' : 'common.successfullyCreated';
        const _title = this.translate.instant('task.task');
        const _msg = this.translate.instant(_label, { section: _title });

        this.helper.successMessage('', _msg);
        this.closeModal({ save: true });
      })
      .catch(error => {
        this.loading = false;
        const errors = get(error, 'error.errors') || [];
        this.helper.setFormError(this.taskForm, false);
        errors.forEach((err: any) => {
          const input = this.taskForm.get(err.fieldName);
          if (!input) return;
          input.setErrors({
            submitted: true,
            message: err.errorMessage
          });
        });

        this.helper.errorMessage(error);
      });
  }

  /**
   * Open a modal instance
   * to confirm task delete
   */
  private confirmDelete() {
    // const modalRef = this.modalService.open(EyrusWarningModalComponent);
    // modalRef.result
    //   .then((res) => this.deleteTask())
    //   .catch(err => { });
  }

  /**
   * Delete task
   */
  private deleteTask() {
    const dailyLogId = this.projectService.dailyLog;
    this.loading = true;
    this.api.dailyLogs.deleteSubmitterTask(dailyLogId, this.currentTask).toPromise()
      .then((res) => {
        const _label = 'common.successfullyDeleted';
        const _title = this.translate.instant('task.task');
        const _msg = this.translate.instant(_label, { section: _title });

        this.helper.successMessage('', _msg);
        this.loading = false;
        this.cancel();
      })
      .catch(err => {
        this.loading = false;
        this.helper.errorMessage(err);
      });
  }

  /**
   * Get current task
   */
  private getCurrentTask() {
    // const task = this.projectService.currentTask || {};
    // const keys = Object.keys(task);
    // if (!keys.length)
    //   return;
    const dailyLogId = this.projectService.dailyLog;
    this.api.dailyLogs.getSubmitterTask(dailyLogId, this.currentTask).toPromise()
      .then(result => {
        var task = result.dailyTaskListItem;
        this.progress = Math.floor((task.percentComplete || 0) * 100);
        this.bootstrapForm(task);
      }).catch(err => {
        this.helper.errorMessage(err);
      });

    //this.bootstrapForm(task);
  }

  /**
   * Initialize task form
   */
  private bootstrapForm(data?: any) {
    this.taskForm = this.formBuilder.group({
      taskName: [data.taskName || '', [Validators.required]],
    });
  }

  /**
   * Remove Icon from header
   */
  private removeIconFromHeader() {
    this.headerService.setIcon({});
  }

  // Generate patch value
  private generatePatchOp(data) {
    return [
      {
        op: 'replace',
        path: '/percentComplete',
        value: (this.progress / 100)
      }
    ];
  }

  /****/


}